/**
 * Clube Coffee++ - Assinatura Anual (Setembro 2026)
 * Visual da mensal + progresso de R$ 119,90, kit de boas-vindas e migração do carrinho.
 */
"use strict";

const VALOR_META = 119.9;
const KIT_VARIANT_ID =
  document.querySelector("[data-kit-variant]")?.getAttribute("data-kit-variant") || "45195341496476";
const STORAGE_KEY = "carrinhoAssinaturaAnual";
const MIGRATION_KEY = "carrinhoMigracaoMensalParaAnual";

class Produto {
  constructor(id, nome, preco, precoOriginal, imagem, quantidade) {
    this.id = id;
    this.nome = nome;
    this.preco = preco;
    this.precoOriginal = precoOriginal;
    this.imagem = imagem;
    this.quantidade = quantidade;
  }
}

let casrtAssinatura = [];

function parsePreco(texto) {
  const match = String(texto || "").match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/);
  if (match) {
    return parseFloat(match[1].replace(/\./g, "") + "." + match[2]) || 0;
  }
  const limpo = String(texto || "")
    .replace("R$", "")
    .replace("/ mês", "")
    .replace("/mês", "")
    .replace("no clube", "")
    .replace("na recompra", "")
    .trim();
  return parseFloat(limpo.replace(/\./g, "").replace(",", ".")) || 0;
}

function formatarPreco(valor) {
  return `R$ ${valor.toFixed(2).replace(".", ",")}`;
}

function totalCarrinhoValores() {
  const itens = casrtAssinatura.reduce((t, p) => t + parseInt(p.quantidade, 10), 0);
  const preco = casrtAssinatura.reduce((t, p) => t + parsePreco(p.preco) * parseInt(p.quantidade, 10), 0);
  return { itens, preco };
}

function salvarCarrinhoNoSessionStorage() {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(casrtAssinatura));
  } catch (error) {
    console.error("Erro ao salvar carrinho:", error);
  }
}

function recuperarCarrinhoDoSessionStorage() {
  try {
    const salvo = sessionStorage.getItem(STORAGE_KEY);
    if (!salvo) return [];
    return JSON.parse(salvo).map(
      (p) => new Produto(p.id, p.nome, p.preco, p.precoOriginal, p.imagem, p.quantidade)
    );
  } catch (error) {
    console.error("Erro ao recuperar carrinho:", error);
    return [];
  }
}

function mapaCardsPorId() {
  const mapa = {};
  document.querySelectorAll(".cacm-produto-card[data-id], .clube-produto-card[data-id]").forEach((card) => {
    const id = card.getAttribute("data-id");
    if (!id) return;
    mapa[String(id)] = {
      id,
      nome: card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome")?.textContent?.trim() || "",
      preco:
        card.querySelector(".cacm-produto-card__preco-atual, .clube-produto-card__preco")?.textContent?.trim() || "",
      precoOriginal:
        card.querySelector(".cacm-produto-card__preco-original, .clube-produto-card__de s")?.textContent?.trim() || "",
      imagem: card.querySelector(".cacm-produto-card__imagem, .clube-produto-card__imagem img")?.getAttribute("src") || "",
    };
  });
  return mapa;
}

function aplicarCarrinhoMigrado() {
  try {
    const raw = sessionStorage.getItem(MIGRATION_KEY);
    if (!raw) return false;
    const itens = JSON.parse(raw);
    sessionStorage.removeItem(MIGRATION_KEY);
    if (!Array.isArray(itens) || !itens.length) return false;
    const mapa = mapaCardsPorId();
    casrtAssinatura = [];
    itens.forEach((item) => {
      const dados = mapa[String(item.id)];
      const qty = String(item.quantidade || 1);
      if (dados) {
        const existente = casrtAssinatura.find((p) => p.id === dados.id);
        if (existente) {
          existente.quantidade = String(parseInt(existente.quantidade, 10) + parseInt(qty, 10));
        } else {
          casrtAssinatura.push(
            new Produto(dados.id, dados.nome, dados.preco, dados.precoOriginal, dados.imagem, qty)
          );
        }
        return;
      }
      if (item.id && item.nome) {
        casrtAssinatura.push(
          new Produto(String(item.id), item.nome, item.preco || "", item.precoOriginal || "", item.imagem || "", qty)
        );
      }
    });
    salvarCarrinhoNoSessionStorage();
    return casrtAssinatura.length > 0;
  } catch (error) {
    console.error("Erro na migração do carrinho:", error);
    sessionStorage.removeItem(MIGRATION_KEY);
    return false;
  }
}

function mostrarToast(mensagem) {
  const toast = document.getElementById("cacm-toast");
  if (!toast) return;
  const toastMessage = toast.querySelector(".cacm-toast__message");
  if (toastMessage) toastMessage.textContent = mensagem;
  toast.classList.add("show");
  setTimeout(() => toast.classList.remove("show"), 3000);
}

function desabilitarBotaoTemporariamente(botao, tempo = 1500) {
  const textoOriginal = botao.textContent;
  botao.setAttribute("disabled", "true");
  botao.textContent = "Adicionado ✓";
  setTimeout(() => {
    botao.removeAttribute("disabled");
    botao.textContent = textoOriginal;
  }, tempo);
}

function atualizarContadorHeader(totalItens) {
  const contador = document.getElementById("cacm-header-carrinho-contador");
  if (!contador) return;
  contador.textContent = String(totalItens);
  contador.classList.toggle("show", totalItens > 0);
}

function atualizarProgresso(preco, textoEl, fillEl, barraEl) {
  const percentual = Math.min((preco / VALOR_META) * 100, 100);
  const restante = Math.max(VALOR_META - preco, 0);
  const largura = `${percentual}%`;
  if (fillEl) {
    fillEl.style.display = "block";
    fillEl.style.width = largura;
    fillEl.style.setProperty("--progress-width", largura);
  }
  if (barraEl) barraEl.style.setProperty("--progress-width", largura);
  if (!textoEl) return;
  if (preco >= VALOR_META) {
    textoEl.textContent = "PARABÉNS — você está apto para o plano anual";
    textoEl.classList.add("parabens");
  } else {
    textoEl.textContent = `Faltam ${formatarPreco(restante)} /mês para assinar o Anual`;
    textoEl.classList.remove("parabens");
  }
}

function mostrarMinicart() {
  const minicart = document.querySelector(".cacm-minicartassinatura");
  if (minicart && casrtAssinatura.length > 0) {
    minicart.style.display = "block";
    minicart.classList.add("is-open");
    atualizarMinicart();
  }
}

function fecharMinicart() {
  const minicart = document.querySelector(".cacm-minicartassinatura");
  if (minicart) {
    minicart.style.display = "none";
    minicart.classList.remove("is-open");
  }
}

function atualizarMinicart() {
  const { itens, preco } = totalCarrinhoValores();
  atualizarContadorHeader(itens);

  const resumoMinicart = document.querySelector(".cacm-minicartassinatura__resumo-valor");
  if (resumoMinicart) {
    resumoMinicart.textContent = `12x ${formatarPreco(preco)} / ${itens} ${itens === 1 ? "item" : "itens"}`;
  }

  atualizarProgresso(
    preco,
    document.querySelector(".cacm-minicartassinatura__progresso-texto"),
    document.querySelector(".cacm-minicartassinatura__progresso-preenchimento"),
    document.querySelector(".cacm-minicartassinatura__progresso-barra")
  );

  const botaoVerCarrinho = document.querySelector(".cacm-minicartassinatura__botao");
  const hiperlinkDiscreto = document.querySelector(".cacm-minicartassinatura__hiperlink-discreto");
  if (botaoVerCarrinho) {
    if (preco >= VALOR_META) {
      botaoVerCarrinho.textContent = "ASSINAR";
      botaoVerCarrinho.classList.add("is-assinar");
      if (hiperlinkDiscreto) hiperlinkDiscreto.style.display = "block";
    } else {
      botaoVerCarrinho.textContent = "Ver carrinho";
      botaoVerCarrinho.classList.remove("is-assinar");
      if (hiperlinkDiscreto) hiperlinkDiscreto.style.display = "none";
    }
  }

  if (!itens) fecharMinicart();
}

function montarUrlCarrinho() {
  const parametros = casrtAssinatura.map((item) => `${item.id}:${item.quantidade}`).join(",");
  if (!parametros) return "/cart";
  return `https://coffeemais.com/cart/${KIT_VARIANT_ID}:1,${parametros}`;
}

function abrirCarrinho() {
  const carrinhoOffcanvas = document.getElementById("cacm-carrinho-offcanvas");
  if (!carrinhoOffcanvas) return;
  carrinhoOffcanvas.classList.add("show");
  document.body.style.overflow = "hidden";
  renderizarProdutosCarrinho();
}

function fecharCarrinho() {
  const carrinhoOffcanvas = document.getElementById("cacm-carrinho-offcanvas");
  if (!carrinhoOffcanvas) return;
  carrinhoOffcanvas.classList.remove("show");
  document.body.style.overflow = "";
}

function renderizarProdutosCarrinho() {
  const container = document.getElementById("cacm-carrinho-produtos");
  if (!container) return;
  container.innerHTML = "";
  if (!casrtAssinatura.length) {
    container.innerHTML = '<p style="color:#999;text-align:center;padding:40px 0;">Seu carrinho está vazio.</p>';
    atualizarResumoCarrinho();
    return;
  }

  casrtAssinatura.forEach((produto, index) => {
    const itemEl = document.createElement("div");
    itemEl.className = "cacm-carrinho-item";
    itemEl.setAttribute("data-index", String(index));
    itemEl.innerHTML = `
      <img src="${produto.imagem}" alt="${produto.nome}" class="cacm-carrinho-item__imagem">
      <div class="cacm-carrinho-item__coluna-nome">
        <div class="cacm-carrinho-item__nome">${produto.nome}</div>
        <div style="font-size:13px;color:#29cc40;font-weight:600;">${produto.preco}</div>
      </div>
      <div class="cacm-carrinho-item__quantidade">
        <button class="cacm-carrinho-item__quantidade-botao" data-action="diminuir" type="button" aria-label="Diminuir">-</button>
        <span class="cacm-carrinho-item__quantidade-valor">${produto.quantidade}</span>
        <button class="cacm-carrinho-item__quantidade-botao" data-action="aumentar" type="button" aria-label="Aumentar">+</button>
      </div>
    `;
    container.appendChild(itemEl);
  });

  container.querySelectorAll(".cacm-carrinho-item__quantidade-botao").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const itemEl = e.target.closest(".cacm-carrinho-item");
      const index = parseInt(itemEl?.getAttribute("data-index") || "0", 10);
      if (btn.dataset.action === "aumentar") aumentarQuantidadeCarrinho(index);
      else diminuirQuantidadeCarrinho(index);
    });
  });

  atualizarResumoCarrinho();
}

function aumentarQuantidadeCarrinho(index) {
  if (!casrtAssinatura[index]) return;
  casrtAssinatura[index].quantidade = String(parseInt(casrtAssinatura[index].quantidade, 10) + 1);
  salvarCarrinhoNoSessionStorage();
  renderizarProdutosCarrinho();
  atualizarMinicart();
  mostrarToast("Quantidade atualizada!");
}

function diminuirQuantidadeCarrinho(index) {
  if (!casrtAssinatura[index]) return;
  const qtd = parseInt(casrtAssinatura[index].quantidade, 10);
  if (qtd > 1) {
    casrtAssinatura[index].quantidade = String(qtd - 1);
    mostrarToast("Quantidade atualizada!");
  } else {
    casrtAssinatura.splice(index, 1);
    mostrarToast("Produto removido do carrinho!");
  }
  salvarCarrinhoNoSessionStorage();
  renderizarProdutosCarrinho();
  atualizarMinicart();
  if (!casrtAssinatura.length) setTimeout(fecharCarrinho, 1200);
}

function atualizarResumoCarrinho() {
  const { itens, preco } = totalCarrinhoValores();
  const totalEl = document.getElementById("cacm-carrinho-total");
  const itensEl = document.getElementById("cacm-carrinho-itens");
  const botaoAssinar = document.querySelector(".cacm-carrinho-offcanvas__botao-assinar");

  if (totalEl) totalEl.textContent = formatarPreco(preco);
  if (itensEl) itensEl.textContent = String(itens);

  atualizarProgresso(
    preco,
    document.querySelector(".cacm-carrinho-offcanvas__progresso-texto"),
    null,
    document.querySelector(".cacm-carrinho-offcanvas__progresso-barra")
  );

  if (!botaoAssinar) return;
  const linkAssinar = botaoAssinar.closest("a");
  if (preco >= VALOR_META) {
    botaoAssinar.removeAttribute("disabled");
    if (linkAssinar) linkAssinar.href = montarUrlCarrinho();
  } else {
    botaoAssinar.setAttribute("disabled", "true");
    if (linkAssinar) linkAssinar.removeAttribute("href");
  }
}

function abrirModalProduto(card) {
  const modal = document.getElementById("cacm-produto-modal");
  const modalImagem = document.getElementById("cacm-produto-modal-imagem");
  const modalTitulo = document.getElementById("cacm-produto-modal-titulo");
  const img = card.querySelector(".cacm-produto-card__imagem, .clube-produto-card__imagem");
  const titulo = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome");
  if (!modal || !modalImagem || !modalTitulo || !img || !titulo) return;

  modalImagem.src = img.src || img.getAttribute("src") || "";
  modalImagem.alt = img.alt || titulo.textContent;
  modalTitulo.textContent = titulo.textContent;

  const descCurta = document.getElementById("cacm-produto-modal-descricao-curta");
  const regiao = document.getElementById("cacm-produto-modal-regiao");
  const notas = document.getElementById("cacm-produto-modal-notas");
  const torra = document.getElementById("cacm-produto-modal-torra");
  const tipo = document.getElementById("cacm-produto-modal-tipo");

  if (descCurta) {
    descCurta.innerHTML = `<p>${card.getAttribute("data-descricao-curta") || "Café 100% arábica de origem controlada."}</p>`;
  }
  if (regiao) regiao.textContent = card.getAttribute("data-regiao") || "Brasil";
  if (notas) notas.textContent = card.getAttribute("data-notas-sensoriais") || "Notas Especiais";
  if (torra) torra.textContent = card.getAttribute("data-torra") || "Média";
  if (tipo) tipo.textContent = card.getAttribute("data-variedade") || "100% Arábica";

  modal.classList.add("show");
  document.body.style.overflow = "hidden";
}

function fecharModalProduto() {
  const modal = document.getElementById("cacm-produto-modal");
  if (!modal) return;
  modal.classList.remove("show");
  document.body.style.overflow = "";
}

const dadosRecomendacao = {
  "6": {
    graoMoido: "7 pacotes",
    capsula: "18 caixas",
    drip: "18 caixas",
    textoHeader: "Para você que consome +6 xícaras por dia o recomendado é:",
  },
  "5": {
    graoMoido: "6 pacotes",
    capsula: "15 caixas",
    drip: "15 caixas",
    textoHeader: "Para você que consome 5 xícaras por dia o recomendado é:",
  },
  "4": {
    graoMoido: "5 pacotes",
    capsula: "12 caixas",
    drip: "12 caixas",
    textoHeader: "Para você que consome 4 xícaras por dia o recomendado é:",
  },
  "3": {
    graoMoido: "4 pacotes",
    capsula: "9 caixas",
    drip: "9 caixas",
    textoHeader: "Para você que consome entre 1 e 3 xícaras por dia o recomendado é:",
  },
};

function configurarCalculadora() {
  const botoesDose = document.querySelectorAll(".clube-dose-btn");
  const headerResultado = document.getElementById("clube-calc-header");
  const qtdGraoMoido = document.getElementById("clube-calc-grao-moido");
  const qtdCapsula = document.getElementById("clube-calc-capsula");
  const qtdDrip = document.getElementById("clube-calc-drip");
  const listaItens = document.querySelector(".clube-calculadora__lista-itens");
  const blocoMensal = document.getElementById("clube-calc-mensal");

  const aplicarDose = (dose) => {
    const config = dadosRecomendacao[dose] || dadosRecomendacao["6"];
    if (headerResultado) headerResultado.textContent = config.textoHeader;
    if (qtdGraoMoido) qtdGraoMoido.textContent = config.graoMoido;
    if (qtdCapsula) qtdCapsula.textContent = config.capsula;
    if (qtdDrip) qtdDrip.textContent = config.drip;
    if (listaItens) listaItens.hidden = dose === "3";
    if (blocoMensal) blocoMensal.hidden = dose !== "3";
  };

  botoesDose.forEach((btn) => {
    btn.addEventListener("click", () => {
      botoesDose.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      aplicarDose(btn.getAttribute("data-dose") || "6");
    });
  });

  const ativo = document.querySelector(".clube-dose-btn.active");
  aplicarDose(ativo?.getAttribute("data-dose") || "6");
}

function hashTabId() {
  const hash = (window.location.hash || "").replace(/^#/, "");
  if (!hash) return "";
  if (hash.startsWith("tab-")) return hash.slice(4);
  return hash;
}

function ativarAbaCatalogo(section, targetTab) {
  if (!targetTab) return false;
  const tabBtns = section.querySelectorAll(".clube-tab-btn");
  const tabPanes = section.querySelectorAll(".clube-tab-pane");
  const targetPane = section.querySelector(`#tab-${targetTab}`);
  const targetBtn = section.querySelector(`.clube-tab-btn[data-tab="${targetTab}"]`);
  if (!targetPane || !targetBtn) return false;

  tabBtns.forEach((b) => b.classList.remove("active"));
  tabPanes.forEach((p) => p.classList.remove("active"));
  targetBtn.classList.add("active");
  targetPane.classList.add("active");
  return true;
}

function aplicarHashCatalogo() {
  const tabId = hashTabId();
  if (!tabId) return;

  document.querySelectorAll(".clube-catalogo-section").forEach((section) => {
    if (!ativarAbaCatalogo(section, tabId)) return;
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

function configurarTabsCatalogo() {
  document.querySelectorAll(".clube-catalogo-section").forEach((section) => {
    const tabBtns = section.querySelectorAll(".clube-tab-btn");
    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        ativarAbaCatalogo(section, btn.getAttribute("data-tab"));
      });
    });
  });

  aplicarHashCatalogo();
  window.addEventListener("hashchange", aplicarHashCatalogo);
}

document.addEventListener("DOMContentLoaded", () => {
  const migrado = aplicarCarrinhoMigrado();
  if (!migrado) casrtAssinatura = recuperarCarrinhoDoSessionStorage();
  atualizarMinicart();
  if (casrtAssinatura.length) mostrarMinicart();
  if (migrado) abrirCarrinho();

  configurarCalculadora();
  configurarTabsCatalogo();

  document
    .querySelectorAll(".cacm-produto-card__quantidade-botao, .clube-produto-card__quantidade-botao")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const container = btn.closest(
          ".cacm-produto-card__quantidade-container, .clube-produto-card__quantidade-container"
        );
        const valorEl = container?.querySelector(
          ".cacm-produto-card__quantidade-valor, .clube-produto-card__quantidade-valor"
        );
        let valor = parseInt(valorEl?.textContent || "1", 10);
        if (btn.textContent.trim() === "+") valor += 1;
        else if (btn.textContent.trim() === "-") valor = Math.max(1, valor - 1);
        if (valorEl) valorEl.textContent = String(valor);
      });
    });

  document.querySelectorAll(".cacm-produto-card__botao-assinar, .clube-produto-card__botao-assinar").forEach((btn) => {
    btn.addEventListener("click", () => {
      const card = btn.closest(".cacm-produto-card, .clube-produto-card");
      if (!card) return;
      const id = card.getAttribute("data-id") || "";
      const nome = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome")?.textContent?.trim() || "";
      const preco =
        card.querySelector(".cacm-produto-card__preco-atual, .clube-produto-card__preco")?.textContent?.trim() || "";
      const precoOriginal =
        card.querySelector(".cacm-produto-card__preco-original, .clube-produto-card__de s")?.textContent?.trim() || "";
      const imagem =
        card.querySelector(".cacm-produto-card__imagem, .clube-produto-card__imagem")?.getAttribute("src") || "";
      const qtdCard = parseInt(
        card.querySelector(".cacm-produto-card__quantidade-valor, .clube-produto-card__quantidade-valor")?.textContent ||
          "1",
        10
      );

      const itemExistente = casrtAssinatura.find((p) => p.id === id);
      if (itemExistente) {
        itemExistente.quantidade = String(parseInt(itemExistente.quantidade, 10) + qtdCard);
        mostrarToast(`Quantidade atualizada! Total: ${itemExistente.quantidade}`);
      } else {
        casrtAssinatura.push(new Produto(id, nome, preco, precoOriginal, imagem, String(qtdCard)));
        mostrarToast(`"${nome}" adicionado!`);
      }

      salvarCarrinhoNoSessionStorage();
      desabilitarBotaoTemporariamente(btn);
      mostrarMinicart();
    });
  });

  document.querySelectorAll(".cacm-produto-card, .clube-produto-card").forEach((card) => {
    const imgContainer = card.querySelector(
      ".cacm-produto-card__imagem-container, .clube-produto-card__imagem-container, .cacm-destaque-1953__imagem"
    );
    const nomeEl = card.querySelector(".cacm-produto-card__nome, .clube-produto-card__nome");
    const lupa = card.querySelector(".cacm-produto-card__lupa-overlay");
    [imgContainer, nomeEl, lupa].forEach((el) => {
      if (!el) return;
      el.addEventListener("click", (e) => {
        if (!e.target.closest("button")) abrirModalProduto(card);
      });
    });
  });

  document.getElementById("cacm-header-carrinho-botao")?.addEventListener("click", abrirCarrinho);
  document.querySelector(".cacm-minicartassinatura__fechar")?.addEventListener("click", fecharMinicart);
  document.getElementById("cacm-carrinho-fechar")?.addEventListener("click", fecharCarrinho);
  document.querySelector(".cacm-carrinho-offcanvas__overlay")?.addEventListener("click", fecharCarrinho);
  document.getElementById("cacm-produto-modal-fechar")?.addEventListener("click", fecharModalProduto);
  document.querySelector(".cacm-produto-modal__overlay")?.addEventListener("click", fecharModalProduto);

  document.querySelector(".cacm-minicartassinatura__botao")?.addEventListener("click", (e) => {
    e.preventDefault();
    const { preco } = totalCarrinhoValores();
    if (preco >= VALOR_META) window.location.href = montarUrlCarrinho();
    else abrirCarrinho();
  });

  document.querySelector(".cacm-minicartassinatura__hiperlink-discreto")?.addEventListener("click", (e) => {
    e.preventDefault();
    abrirCarrinho();
  });

  document.querySelector(".cacm-carrinho-offcanvas__botao-assinar")?.addEventListener("click", (e) => {
    const { preco } = totalCarrinhoValores();
    if (preco < VALOR_META) {
      e.preventDefault();
      return;
    }
    const link = e.currentTarget.closest("a");
    if (link) link.href = montarUrlCarrinho();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    fecharModalProduto();
    fecharCarrinho();
  });
});
